<div class="summary-list">
  <span class="summary-list__header">
    {{ title }}
  </span>
  <ul class="summary-list__items">
    @for (option of options; track option) {
      <li class="summary-list__items__item">
        {{ option }}
      </li>
    }
  </ul>
</div>
